/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './survey-units-of-measure.reducer';

export const SurveyUnitsOfMeasureDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const surveyUnitsOfMeasureEntity = useAppSelector(state => state.surveyUnitsOfMeasure.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="surveyUnitsOfMeasureDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.surveyUnitsOfMeasure.detail.title">SurveyUnitsOfMeasure</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.surveyUnitsOfMeasure.id">Id</Translate>
            </span>
          </dt>
          <dd>{surveyUnitsOfMeasureEntity.id}</dd>
          <dt>
            <span id="unitOfMeasuresName">
              <Translate contentKey="tinyMedicRestApp.surveyUnitsOfMeasure.unitOfMeasuresName">Unit Of Measures Name</Translate>
            </span>
          </dt>
          <dd>{surveyUnitsOfMeasureEntity.unitOfMeasuresName}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.surveyUnitsOfMeasure.active">Active</Translate>
            </span>
          </dt>
          <dd>{surveyUnitsOfMeasureEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.surveyUnitsOfMeasure.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{surveyUnitsOfMeasureEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.surveyUnitsOfMeasure.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{surveyUnitsOfMeasureEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.surveyUnitsOfMeasure.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{surveyUnitsOfMeasureEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.surveyUnitsOfMeasure.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{surveyUnitsOfMeasureEntity.timestampentry}</dd>
        </dl>
        <Button tag={Link} to="/survey-units-of-measure" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/survey-units-of-measure/${surveyUnitsOfMeasureEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SurveyUnitsOfMeasureDetail;
